export default __webpack_public_path__ + "static/media/Overall schedule 2.62456726.png";